import { IEmployeesPaths } from '@/types';

export const EMPLOYEES_PATHS: IEmployeesPaths = {
  LIST: {
    _: 'employees/list/',
  },
  UPLOAD_EMPLOYEES: {
    BY_ID: (companyId: string, cohortId?: string) => `employees/upload/${companyId}/${cohortId}`,
  },
  UPLOAD_EMPLOYEES_STATUS: {
    _: 'employees/upload-status/',
  },
  TERMINATE: {
    _: 'employees/terminate/',
  },
  EXPORT: {
    _: 'employee/export/',
  },
};
